import { render, staticRenderFns } from "./PaymentNewDashboards.vue?vue&type=template&id=6b9bbdbf&scoped=true"
import script from "./PaymentNewDashboards.vue?vue&type=script&lang=ts"
export * from "./PaymentNewDashboards.vue?vue&type=script&lang=ts"
import style0 from "./PaymentNewDashboards.vue?vue&type=style&index=0&id=6b9bbdbf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9bbdbf",
  null
  
)

export default component.exports